import { AnyObject } from "final-form";
import {
  REDIRECT_CUSTOM_URL,
  REDIRECT_SPECIFIC_BLOG_POST,
  REDIRECT_SPECIFIC_PRODUCT_PAGE,
  REDIRECT_SPECIFIC_SHOPIFY_PAGE
} from "../../../../../constants/redirectTypes.js";
import isUrl from "is-valid-http-url";

export const validate = (values) => {
  const errors: AnyObject = {};

  if (values.hideProductIsActiveTags && !values.hideProductSelectedTags.length) {
    errors.hideProductSelectedTags = "Tag required";
  }

  if (values.downProductIsActiveTags && !values.downProductSelectedTags.length) {
    errors.downProductSelectedTags = "Tag required";
  }

  if (values.backProductIsActiveVisibleTags && !values.backProductVisibleSelectedTags.length) {
    errors.backProductVisibleSelectedTags = "Tag required";
  }

  if (values.backProductIsActiveExcludeTags && !values.backProductExcludeSelectedTags.length) {
    errors.backProductExcludeSelectedTags = "Tag required";
  }

  if (values.hideProductRedirect === REDIRECT_SPECIFIC_SHOPIFY_PAGE && !values.hideProductSpecificShopifyPage.length) {
    errors.hideProductSpecificShopifyPage = "Page selection required";
  }

  if (values.hideProductRedirect === REDIRECT_SPECIFIC_PRODUCT_PAGE && !values.hideProductSpecificProductPage.length) {
    errors.hideProductSpecificProductPage = "Page selection required";
  }

  if (values.hideProductRedirect === REDIRECT_SPECIFIC_BLOG_POST && !values.hideProductSpecificShopifyBlog.length) {
    errors.hideProductSpecificShopifyBlog = "Page selection required";
  }

  if (values.hideProductRedirect === REDIRECT_CUSTOM_URL && !values.hideProductCustomRedirectURL) {
    errors.hideProductCustomRedirectURL = "Address Required";
  }

  if (values.hideProductRedirect === REDIRECT_CUSTOM_URL && values.hideProductCustomRedirectURL && !isUrl(values.hideProductCustomRedirectURL)) {
    errors.hideProductCustomRedirectURL = "Address is not valid";
  }

  // Location settings validation
  if (values.locationSettings) {
    if (!values.locationSettings.monitorAllLocations && (!values.locationSettings.selectedLocationNames || values.locationSettings.selectedLocationNames.length === 0)) {
      errors["locationSettings.selectedLocationNames"] = "At least one location must be selected";
    }
  }

  return errors;
};